<template>
    <el-dialog title="通知中心" center :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
        <div class="centent">
            <el-collapse v-model="activeName" accordion v-for="(item,index) in messageList" :key="index" @change="handleChange(item)">
                <el-collapse-item :name="index">
                    <template slot="title">
                        <div v-if="item.status == 1">
                            <i class="el-icon-bell"></i> <span style="margin-left: 10px;">{{ item.title }}</span>
                        </div>
                        <div v-else>
                            {{ item.title }}
                        </div>
                    </template>
                    <div>{{ item.message }}</div>
                </el-collapse-item>
            </el-collapse>
        </div>

        <!--分页-->
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    :current-page="search.page"
                    :page-size="search.list_rows" layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber">
            </el-pagination>
        </div>

    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';

    export default {
        data() {
            return {
                activeName: '',
                loading: false,
                // 是否显示
                dialogVisible: true,
                // 一共多少条数据
                totalDataNumber: 0,
                search: {
                    status: 2,
                    page: 0,
                    list_rows: 10,
                },
                messageList: [],
            };
        },
        props: [],
        created() {
            this.getTableList()
        },
        methods: {
            // 消息列表
            getTableList() {
                let that = this;

                UserApi.getMessage(that.search,true)
                    .then(res => {
                        that.loading = false;
                        that.messageList = res.data.list.data;
                        that.totalDataNumber = res.data.list.total
                    })
                    .catch(error => {
                        that.loading = false;
                    });
            },

            // 选择第几页
            handleCurrentChange(val) {
                let that = this;
                that.search.page = val;
                that.loading = true;
                that.getTableList();
            },

            // 每页多少条
            handleSizeChange(val) {
                this.search.page = 1;
                this.search.list_rows = val;
                this.getTableList();
            },

            // 已读消息
            handleChange(val) {
                if (val.status == 1){
                    UserApi.updateMessage({
                        message_id: val.message_id
                    },true)
                        .then(res => {
                            this.getTableList()
                        })
                        .catch(error => {

                        });
                }
            },

            // 关闭弹窗
            dialogFormVisible() {
                this.$emit('close', false);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .centent{
        max-height: 500px;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/part/Message.vue